import { render, staticRenderFns } from "./FacturasCartaporte.vue?vue&type=template&id=2b6f13c8&"
import script from "./FacturasCartaporte.vue?vue&type=script&lang=js&"
export * from "./FacturasCartaporte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports